<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <tenants-table />
      </div>
    </div>
  </div>
</template>

<script>
import TenantsTable from "./components/TenantsTable.vue";

export default {
  name: "Tenants",
  components: {
    TenantsTable,
  },
};
</script>
